import { type ReactNode, useState } from 'react'

import { cn } from '@/lib/utils'

export type AnimatedIdsRef = React.RefObject<Set<string>>

export interface ChatAnimatedItemProps {
  itemId: string

  animatedIdsRef: AnimatedIdsRef

  children: ReactNode

  className?: string
}

export const ChatAnimatedItem: React.FC<ChatAnimatedItemProps> = ({
  itemId,
  animatedIdsRef,
  children,
  className,
}): ReactNode => {
  const [shouldAnimate] = useState(() => {
    if (animatedIdsRef.current?.has(itemId)) {
      return false
    }
    animatedIdsRef.current?.add(itemId)
    return true
  })

  return (
    <div
      className={cn(
        shouldAnimate &&
          'animate-in fade-in slide-in-from-bottom-2 duration-300 fill-mode-forwards',
        className
      )}
    >
      {children}
    </div>
  )
}

ChatAnimatedItem.displayName = 'ChatAnimatedItem'
